// export const URL_API = 'http://103.238.71.121:10001';
// export const URL_API = 'http://84.247.147.231:9001';
// export const URL_API = 'http://localhost:9001';
// export const URL_API = 'http://localhost:10001';
export const URL_API = 'https://quanly.classbk.com';

// WebSocket URL - connect directly to schooloffice (Zuul gateway doesn't support WebSocket)
// export const URL_WS = 'http://103.238.71.121:10004';
// export const URL_WS ci= 'http://84.247.147.231:9004';
// export const URL_WS = 'wss://ws.timesschools.edu.vn';

// export const URL_WS = 'http://localhost:10004';
export const URL_WS = 'https://quanly.classbk.com';
// export const URL_IMG_PUB = URL_API + "/api/one-book-resource/    public/show-avatar/"
// export const
// URL_API select-plan-stelp-1= 'http://61.14.237.86:9001';